import React from 'react';
import { motion } from 'framer-motion';
import { openWhatsApp } from '../lib/whatsapp';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight } = FiIcons;

function StudioSection() {
  return (
    <section className="studio-section" id="studio">
      <div className="studio-image">
        <img
          src="https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1400&q=85"
          alt="Quiet, layered interior with vintage furniture and natural materials"
          loading="lazy"
        />
        <span>Material, memory, and light.</span>
      </div>
      <motion.div
        className="studio-copy"
        initial={{ opacity: 0, x: 24 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.7 }}
      >
        <p className="eyebrow eyebrow-light">A little about us</p>
        <h2>
          Good design is
          <br />
          felt, not <em>announced.</em>
        </h2>
        <p className="studio-description">
          We're a small, curious team designing homes with warmth and intention. We mix old and new, refine the details, and leave room for life to happen.
        </p>
        <div className="studio-signature">
          <span className="signature-line" />
          <div>
            <strong>Clara Bennett</strong>
            <span>Founder & Principal Designer</span>
          </div>
        </div>
        <button
          className="studio-cta"
          type="button"
          onClick={() => openWhatsApp("Hello Forma Interiors, I'd love to learn more about your studio.")}
        >
          Learn more about us
          <SafeIcon icon={FiArrowUpRight} />
        </button>
      </motion.div>
    </section>
  );
}

export default StudioSection;
